import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=3fdc1123&scoped=true"
import script from "./NewMenu.vue?vue&type=script&lang=js"
export * from "./NewMenu.vue?vue&type=script&lang=js"
import style0 from "./NewMenu.vue?vue&type=style&index=0&id=3fdc1123&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc1123",
  null
  
)

export default component.exports